import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import certificateImg from "../../assets/images/certificate.jpg";
import "./Certificate.css";

export function Certificate() {
  const location = useLocation();
  const { firstname, lastname } = location.state || {
    firstname: "Your FirstName",
    lastname: "Your LastName",
  };
  // const [firstname]=useState(localStorage.getItem("firstname"));
  // const[lastname]=useState(localStorage.getItem("lastname"));
  const fullname = `${firstname} ${lastname}`;
  const certificateRef = useRef(null);
  

  const downloadCertificateAsPDF = () => {
    const img = new Image();
    img.src = certificateImg;
    img.crossOrigin = "anonymous"; // Prevent CORS issues

    img.onload = () => {
      const imgWidth = 210; // A4 width in mm (portrait)
      const imgHeight = 297; // A4 height in mm (portrait)

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      pdf.addImage(img, "JPEG", 0, 0, imgWidth, imgHeight);

      // Position adjustments (in mm)
      const textCenterX = imgWidth / 2; // Centered text
      const fullnameY = imgHeight * 0.45; // Name position (unchanged)

      pdf.setFont("times", "italic"); // Times New Roman Italic
      pdf.setFontSize(24);
      pdf.setTextColor(0, 0, 0);
      pdf.text(fullname, textCenterX, fullnameY, { align: "center" });

     
    };
  };
  

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }} className="container">
      {/* <h2>Certificate Preview</h2> */}

      {/* Certificate Container */}
      <div
        ref={certificateRef} className="certificateImg"
        style={{ position: "relative", display: "inline-block" }}
      >
        <img src={certificateImg} alt="Certificate" width="800" />

        {/* Name (Centered) */}
        <div className="nameCertificate"
    //  style={{
    //     position: "absolute",
    //     top: "45%",
    //     left: "50%",
    //     transform: "translate(-50%, -50%)",
    //     fontSize: "24px",
    //     fontWeight: "normal",
    //     color: "black",
    //     fontFamily: '"Times New Roman", Times, serif',
    //     fontStyle: "italic",
    //     whiteSpace: "nowrap", 
    //   }}
        >
          {fullname}
        </div>
      </div>

      {/* Download PDF Button */}
  
      <div className="btnProceed btnDownload"  >
       
        <button onClick={downloadCertificateAsPDF}>
          Download Certificate as PDF
        </button>
      </div>
    </div>
  );
}
